<!-- TODO: if icon doesn't have text label (prop "text" is undefined) than it should be moved to the bottom by 2-3 px (because when it's lean to the top a bit when it placed near by regular button or any other elements) -->
<template>
  <component
    :is="tag"
    :class="{
      'icon-button': true,
      'icon-button--disabled': disabled,
      'icon-button--gray': color === 'gray',
      'icon-button--blue': color === 'blue',
      'icon-button--red': color === 'red',
    }"
    @click="onClick($event)"
  >
    <!-- Single icon -->
    <span
      v-if="imgSrc"
      ref="iconContainer1"
      :class="{
        'icon-button__icon': true,
        'icon-button__icon--nano': size === 'nano',
        'icon-button__icon--tiny': size === 'tiny',
        'icon-button__icon--small': size === 'small',

        'icon-button__icon--gray': color === 'gray',
        'icon-button__icon--blue': color === 'blue',
        'icon-button__icon--red': color === 'red',
      }"
    >
      <img :src="imgSrc" alt="raster-icon" />
    </span>
    <!-- / Single icon -->

    <span
      v-if="!imgSrc && icon && !iconSecondary"
      ref="iconContainer2"
      :class="{
        'icon-button__icon': true,
        'icon-button__icon--nano': size === 'nano',
        'icon-button__icon--tiny': size === 'tiny',
        'icon-button__icon--small': size === 'small',

        'icon-button__icon--filled': filled,
        'icon-button__icon--filled-dark': filledDark,

        'icon-button__icon--gray': color === 'gray',
        'icon-button__icon--blue': color === 'blue',
        'icon-button__icon--red': color === 'red',
      }"
      v-html="icon"
    >
    </span>
    <!-- / Single icon -->

    <!-- 2 icons mode -->
    <span
      v-if="icon && iconSecondary"
      :class="{
        'icon-button__icon': true,

        'icon-button__icon--gray': color === 'gray',
        'icon-button__icon--blue': color === 'blue',
        'icon-button__icon--red': color === 'red',

        'icon-button__icon--filled': filled,
        'icon-button__icon--filled-dark': filledDark,

        'icon-button__icon--composite': true,
      }"
    >
      <span
        ref="iconContainer3"
        :class="{
          'icon-button__sub-icon': true,
          'icon-button__sub-icon--big': true,
        }"
        v-html="icon"
      ></span>
      <span
        ref="iconContainer4"
        class="icon-button__sub-icon icon-button__sub-icon--small"
        v-html="iconSecondary"
      ></span>
    </span>
    <!-- / 2 icons mode -->

    <slot />

    <span v-if="text" class="icon-button__label">
      {{ text }}
    </span>
  </component>
</template>

<script>
export default {
  name: 'icon-button',

  emits: ['click'],

  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (size) => ['nano', 'tiny', 'small', 'medium', 'large'].includes(size),
    },
    icon: { type: String },
    tag: { type: String, default: 'button' },
    imgSrc: { type: String },
    // iconSecondary value sometimes can be null, type of null is "Object"
    iconSecondary: { type: [String, Object] },
    text: { type: String, required: false },
    color: { type: String, default: 'gray', validator: (color) => ['gray', 'blue', 'red'].includes(color) },
    filled: { type: Boolean, default: false },
    filledDark: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    iconScale: { type: Number, default: 1 },
    iconVerticalShift: { type: [Number, String], default: 'auto' }, // Vertical shift in percents (percents instead of pixels is used to skip conversion to REM's)
  },

  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },

    addSizeToSVGNodes() {
      const icon1 = this.$refs.iconContainer1?.children[0];
      const icon2 = this.$refs.iconContainer2?.children[0];
      const icon3 = this.$refs.iconContainer3?.children[0];
      const icon4 = this.$refs.iconContainer4?.children[0];
      if (icon1) {
        icon1.style.width = this.iconScale * 100 + '%';
        icon1.style.minWidth = this.iconScale * 100 + '%';
        icon1.style.height = this.iconScale * 100 + '%';
        icon1.style.minHeight = this.iconScale * 100 + '%';
      }
      if (icon2) {
        icon2.style.width = this.iconScale * 100 + '%';
        icon2.style.minWidth = this.iconScale * 100 + '%';
        icon2.style.height = this.iconScale * 100 + '%';
        icon2.style.minHeight = this.iconScale * 100 + '%';
      }
      if (icon3) {
        icon3.style.width = this.iconScale * 100 + '%';
        icon3.style.minWidth = this.iconScale * 100 + '%';
        icon3.style.height = this.iconScale * 100 + '%';
        icon3.style.minHeight = this.iconScale * 100 + '%';
      }
      if (icon4) {
        icon4.style.width = this.iconScale * 100 + '%';
        icon4.style.minWidth = this.iconScale * 100 + '%';
        icon4.style.height = this.iconScale * 100 + '%';
        icon4.style.minHeight = this.iconScale * 100 + '%';
      }
    },

    addShiftToSVGNodes() {
      const icon1 = this.$refs.iconContainer1?.children[0];
      const icon2 = this.$refs.iconContainer2?.children[0];
      const icon3 = this.$refs.iconContainer3?.children[0];
      const icon4 = this.$refs.iconContainer4?.children[0];

      if (icon1) icon1.style.transform = `translateY(${this.iconVerticalShift + '%'})`;
      if (icon2) icon2.style.transform = `translateY(${this.iconVerticalShift + '%'})`;
      if (icon3) icon3.style.transform = `translateY(${this.iconVerticalShift + '%'})`;
      if (icon4) icon4.style.transform = `translateY(${this.iconVerticalShift + '%'})`;
    },
  },

  mounted() {
    this.addSizeToSVGNodes();
    this.addShiftToSVGNodes();
  },

  watch: {
    icon() {
      this.$nextTick(() => {
        this.addSizeToSVGNodes();
        this.addShiftToSVGNodes();
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables';
@import '@styles/media-queries';
@import '@styles/text';

// Icon button ----------------------------------------------------------------
.icon-button {
  padding: 0 3px;
  border: none;
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: $c-dark;
  transition: color 0.15s ease;
  cursor: pointer;
  user-select: none;
  background: transparent;

  &--disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  }

  &__icon {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
    min-height: 2rem;
    margin-bottom: 3px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: relative;
    z-index: 0;
    pointer-events: none;

    &:last-child {
      margin-bottom: 0;
    }

    &--nano {
      width: 1rem;
      min-width: 1rem;
      height: 1rem;
      min-height: 1rem;
    }

    &--tiny {
      width: 1.35rem;
      min-width: 1.35rem;
      height: 1.35rem;
      min-height: 1.35rem;
    }

    &--small {
      width: 1.7rem;
      min-width: 1.7rem;
      height: 1.7rem;
      min-height: 1.7rem;
    }

    &--composite {
      width: 2.7rem;
      min-width: 2.7rem;
      height: 2rem;
      min-height: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
    }

    :deep(svg) {
      fill: $c-dark;
      transition: fill 0.15s ease;
    }

    &--tiny,
    &--small {
      :deep(svg) {
        width: 83%;
        height: 83%;
      }
    }

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 10rem;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: -1;
      transform: translate(-50%, -50%);
      background: rgba(44, 151, 223, 0.13);
      opacity: 0;
      transition:
        width 0.15s ease,
        height 0.15s ease,
        opacity 0.15s ease;
    }

    &--sort::after {
      left: calc(50% - 2px);
    }

    &--gray::after {
      background: rgba($c-dark, 0.11);
    }

    &--blue::after {
      background: rgba(44, 151, 223, 0.13);
    }

    &--red::after {
      background: rgba(255, 0, 0, 0.15);
    }

    &--filled {
      &::after {
        width: 160%;
        height: 160%;
        opacity: 1;
        background: #fff;
        box-shadow: 0 3px 0.6rem rgba(0, 0, 0, 0.16);
        transition:
          width 0.15s ease,
          height 0.15s ease,
          background 0.15s ease;
      }
    }

    &--filled-dark {
      &::after {
        width: 160%;
        height: 160%;
        opacity: 1;
        background: rgba($c-dark, 0.1);
        transition:
          width 0.15s ease,
          height 0.15s ease,
          background 0.15s ease;
      }
    }
  }

  &:hover {
    :deep(svg) {
      fill: $c-dark;
    }
  }

  &--gray:hover {
    :deep(svg) {
      fill: $c-dark;
    }

    .icon-button__icon--filled::after {
      background: #eaecef;
    }
  }

  &--blue:hover {
    :deep(svg) {
      fill: #2c97df;
    }

    .icon-button__icon--filled::after {
      // background: ???;  --- TODO: Figure out proper color
    }
  }

  &--red:hover {
    :deep(svg) {
      fill: rgb(240, 70, 70);
    }

    .icon-button__icon--filled::after {
      background: #ffd9d9;
    }
  }

  &:hover :deep(.icon-button__icon::after) {
    width: 200%;
    height: 200%;
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  &__sub-icon {
    height: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    right: -2px;

    &--big {
      height: 1.8rem;
      min-height: 1.8rem;
      min-width: 1.8rem;
      margin-right: 2px;
    }

    &--small {
      height: 1.3rem;
    }
  }

  &__label {
    @include caption--small;
    // Matches .products-page__clear-all exactly, so the toolbar reads as one set
    // of controls rather than two typographic systems sharing a row.
    font-size: 1.25rem;
    font-weight: 600;
    letter-spacing: normal;
    line-height: 140%;
    text-transform: none;
    color: $c-ink-soft;
    white-space: nowrap;
  }
}
</style>
